/* eslint-disable global-require */
const loginStyle = (theme) => ({
  textFieldCustom: {
    '& > .MuiInput-underline': {
      '&:before': {
        borderBottomColor: '#EBEDEF',
      },
    },
    '& > .MuiFormHelperText-root': {
      maxWidth: '415px',
    },
  },
  forgotPasswordText: {
    color: '#0C91C4',
    fontSize: '14px',
    marginTop: '15px',
    marginBottom: '60px',
    textAlign: 'right',
    textDecoration: 'none',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '45px',
    },
  },
  loginBackgroundContainer: {
    flex: 0.3,
    backgroundImage: `url(${require('assets/img/login_background.png')})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      backgroundImage: `url(${require('assets/img/login_background_mobile.png')})`,
      padding: '20px',
    },
  },
  loginAlibabaBackgroundContainer: {
    backgroundImage: `url(${require('assets/img/alibaba_login_background.png')})`,
    [theme.breakpoints.down('sm')]: {
      backgroundImage: `url(${require('assets/img/alibaba_login_background.png')})`,
    },
  },
  registerBackgroundContainer: {
    flex: 0.3,
    backgroundImage: `url(${require('assets/img/register_background.jpg')})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      backgroundImage: `url(${require('assets/img/register_background_mobile.png')})`,
      flex: 1,
      padding: '20px',
      maxHeight: '230px',
    },
  },
  registerAlibabaBackgroundContainer: {
    backgroundImage: `url(${require('assets/img/alibaba_register_background.png')})`,
    [theme.breakpoints.down('sm')]: {
      backgroundImage: `url(${require('assets/img/alibaba_register_background.png')})`,
    },
  },
  loginRightTitle: {
    fontSize: '40px',
    fontWeight: 'bold',
    color: '#FFFFFF',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
  },
  loginRightSubTitle: {
    fonSize: '14px',
    color: '#FFFFFF',
    textAlign: 'center',
    fontWeight: 'normal',
    maxWidth: '315px',
    marginTop: '20px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
      marginTop: 0,
      maxWidth: '400px',
      lineHeight: '20px',
    },
  },
  loginRightButton: {
    borderColor: '#fff',
    color: '#fff',
    letterSpacing: '0.0357143em',
    fontSize: '14px',
    width: '50%',
    marginTop: '70px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  linkedInButton: {
    borderColor: '#2867B2',
    textTransform: 'none',
    color: '#2867B2',
    fontSize: '14px',
    width: '100%',
    marginTop: '30px',
    marginBottom: '30px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '20px',
      marginBottom: '20px',
    },
  },
  orTitle: {
    color: '#AAAAAA',
    fontSize: '14px',
  },
  login: {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    backgroundColor: 'white',
  },
  icon: {
    width: '160px',
    backgroundSize: 'cover',
    [theme.breakpoints.down('sm')]: {
      width: '110px',
      marginBottom: '20px',
    },
  },
  grid: {
    width: '450px',
  },
  container: {
    padding: '115px 0',
  },
  title: {
    color: '#0C91C4',
    fontWeight: 700,
    fontSize: '36px',
    margin: 0,
    lineHeight: 'normal',
  },
  expiredMessage: {
    fontWeight: '500',
    fontSize: '17px',
    marginBottom: '10px',
  },
  loginContainer: {
    padding: '20px 50px',
    margin: '20px',
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      padding: 0,
    },
  },
  textField: {
    width: '100%',
  },
  btnBlock: {
    margin: '20px 0',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '60px',
    },
  },
  button: {
    background: '#0c91c4',
    color: 'white',
    '&:hover': {
      transition: 'background 0.1s',
      background: '#0a82b0',
    },
  },
  receiveCode: {
    fontSize: '14px',
  },
  receiveCodeLink: {
    color: '#0069ff',
    textDecoration: 'none',
    fontWeight: '500',
  },
  link: {
    color: '#0069ff',
    textDecoration: 'none',
    fontSize: '17px',
    fontWeight: '500',
  },
  notice: {
    width: '100%',
    textAlign: 'center',
    background: '#0c91c4',
    color: 'white',
    fontWeight: '800',
    padding: '10px 0',
    opacity: '0',
    transition: 'opacity .8s ease-in',
    mozTransition: 'opacity .8s ease-in',
    webkitTransition: 'opacity .8s ease-in',
    position: 'fixed',
    top: '0',
  },
  showNotice: {
    opacity: '1',
    zIndex: 9999,
  },
  firstParam: {
    marginBottom: '5px',
  },
  loginFooter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  alink: {
    width: 'max-content',
    fontSize: '12px',
  },
  checkbox: {
    padding: 0,
  },
  password: {
    margin: '0 auto',
    width: '700px',
  }
});

export default loginStyle;
